import { render, staticRenderFns } from "./general.vue?vue&type=template&id=8c5bc3ca&"
import script from "./general.vue?vue&type=script&lang=js&"
export * from "./general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports